module.exports = __webpack_public_path__ + "static/media/chapul-xsmall-navigation.21e6e887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/chapul/chapul-xsmall-navigation.jpg
// module id = 673
// module chunks = 0